// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"6719d23a","209":"5fe870c1","829":"6da9a4bb","878":"a29a0c13"}[chunkId] + ".chunk.js";
};